import { REPORT_CHANGE_ADDRESS_CLICK } from 'redux/modules/address/actions/types';

export const reportChangeAddressClick = () => ({
  type: REPORT_CHANGE_ADDRESS_CLICK,
});
